import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'cms-icon-chevron-left',
  shadow: false,
})
export class CmsIconChevronLeft {
  /**
   * Define the color used to paint the svg element.
   */
  @Prop() dataFill: string = 'currentColor';
  /**
   * The width of the svg element.
   */
  @Prop() dataWidth: string | number = null;

  /**
   * The height of the svg element.
   */
  @Prop() dataHeight: string | number = null;

  render() {   
    return (
      /*@ts-ignore*/
      <svg
        width={this.dataWidth}
        height={this.dataHeight}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.5435 22.6867L28.6789 11.5443C29.4042 10.8187 30.5794 10.8187 31.3055 11.5435C32.0316 12.2682 32.0311 13.4439 31.3063 14.1701L21.4824 23.9999L31.3063 33.8299C32.0316 34.5554 32.0308 35.7312 31.3055 36.4565C30.5802 37.1817 29.4042 37.1809 28.6789 36.4556L17.5435 25.3133C16.8187 24.5878 16.8189 23.4129 17.5435 22.6882V22.6867Z"
          fill={this.dataFill}
        />
      </svg>
    );
  }
}
